
import { computed, defineComponent, PropType } from 'vue'
import { SelectOption } from '@/types/InputItems'

export default defineComponent({
  name: 'InputSelectbox',

  props: {
    id: String,
    name: String,
    options: {
      type: Array as PropType<SelectOption[]>,
      required: true
    },
    selected: String,
    addClass: Object,
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    }
  },

  setup(props, { emit }) {
    const classObject = computed(() => {
      return {
        selectbox: true,
        disabled: props.disabled,
        error: props.error,
        ...props.addClass
      }
    })

    const updateValue = (e: any) => {
      emit('selection-change', e.target.value)
    }

    return {
      classObject,
      updateValue
    }
  }
})
